// @ts-nocheck
import { useMemo } from 'react'
import { type FormInstance } from 'antd'
import { type ForgetPasswordProps } from '.'
import { postApi } from 'src/api'
import { getLocationParams } from 'src/utils'

interface ForgetUtilsParams {
  form1Ref: React.MutableRefObject<FormInstance<{
    user: string,
    email: string,
    verifyCode: string
  }>>,
  form2Ref: React.MutableRefObject<FormInstance<{
    password: string,
    password2: string
  }>>,
  setState: UseStatesDispatch<ForgetPasswordProps>
}

export function useForgetUtils({ form1Ref, form2Ref, setState, setRootState }: ForgetUtilsParams) {
  return useMemo(() => {

    const nextStep = livecloud.debounce(async () => {
      try {
        const { user, phoneOrEmail, verifyCode } = await form1Ref.current.validateFields()
        const res = await postApi('/forgetPassword/changePsw')({
          userId:    user,
          account:   phoneOrEmail,
          code:      verifyCode,
          loginType: 2
        })
        if (res.data === livecloud.REQUEST_ERROR) return
        setState('isVerify', false)
      } catch (e) {
        console.log(e)
      }
    }, 100)

    const finish = livecloud.debounce(async () => {
      const { client_id } = getLocationParams()
      try {
        const { user, phoneOrEmail, verifyCode } = await form1Ref.current.validateFields()
        const { password, password2 } = await form2Ref.current.validateFields()
        AES.setSecret('aas-apex')
        const res = await postApi('/forgetPassword/changePsw')({
          userId:         user,
          account:        phoneOrEmail,
          code:           verifyCode,
          loginType:      2,
          newPwd:         AES.encryptBase64(password),
          newPwd1:        AES.encryptBase64(password2),
          sourceClientId: client_id,
          updateType:     3
        })
        if (res.data === livecloud.REQUEST_ERROR) return
        livecloud.tip.info(res.data)
        // setRootState('isForgetPassword', false)
        removeParamsAndRedirect()
      } catch (e) {
        console.log(e)
      }
    }, 100)

    const removeParamsAndRedirect = () => {
      let url = window.location.href
      let urlObject = new URL(url)
      urlObject.searchParams.delete('pageType')
      urlObject.searchParams.delete('loginId')
      window.location.replace(urlObject.toString())
    }

    return {
      nextStep,
      finish
    }

  }, [])
}